import { defineAsyncComponent } from 'vue';

export const TablefilterNns = defineAsyncComponent(() => import('./TablefilterNns.vue'));
export const TableTopNns = defineAsyncComponent(() => import('./TableTopNns.vue'));
